import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Accordion } from '../../components/Accordion'
import { ClientsBanner } from '../../components/ClientsBanner'

export default function MicroLoan200() {
    return (
        <div>
            <Seo
                title="Prêt rapide de 200$ au Québec | Trouvez les meilleures offres | Argent Aujourd’hui"
                description="Comparez les prêts rapides de 200$ en ligne sur notre site et choisissez l'option idéale. Accédez aux meilleures offres dès maintenant."
                type="webapp"
                name="Argent Aujourd'hui"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt rapide de 200$</h1>

                    <p className="header-subtitle">
                        Obtenez un prêt rapide de 200$ sans enquête de crédit avec Argent
                        Aujourd’hui! Une solution efficace, fiable et entièrement en ligne pour
                        bénéficier de prêts personnels en moins de 24 heures.
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Obtenir un prêt de 200$, c’est simple et rapide avec Argent Aujourd’hui!
                    </h2>

                    <p className="sect-subtitle">
                        La vie est remplie d’imprévus, et parfois, ils peuvent coûter cher! Pour
                        répondre à un besoin immédiat, Argent Aujourd’hui vous propose les
                        meilleures solutions de prêts alternatifs du marché. Avec notre{' '}
                        <b>comparateur en ligne</b>, explorez vos possibilités et faites votre
                        demande de prêt sans document en quelques clics! Pour bénéficier d’un prêt
                        rapide de 200$, vous devez simplement :
                    </p>

                    <div className="steps" style={{ marginTop: 50 }}>
                        <ol>
                            <li>
                                <h3>
                                    <Link to="/new-lead">Remplir notre formulaire en ligne</Link>
                                </h3>
                                <p>
                                    Indiquez-nous vos renseignements personnels ainsi que vos
                                    besoins de prêt personnalisé. Notez que cette démarche est
                                    entièrement confidentielle, et sans engagement!
                                </p>
                            </li>
                            <li>
                                <h3>Explorer les options</h3>
                                <p>
                                    Sur base de votre demande, nous vous proposons différentes
                                    institutions qui pourraient vous obtenir un prêt rapide de 200$.
                                    Pour chacune d’entre elles, comparez leurs conditions, dont le
                                    délai de remboursement du prêt et son coût.
                                </p>
                            </li>
                            <li>
                                <h3>Choisir une institution</h3>
                                <p>
                                    Si vous êtes prêt à faire votre demande, sélectionnez l'une des
                                    institutions en cliquant sur son nom. Vous serez automatiquement
                                    redirigé vers leur formulaire.
                                </p>
                            </li>
                            <li>
                                <h3>Recevoir le prêt en 24 heures</h3>
                                <p>
                                    Vous devrez fournir vos renseignements personnels et fournir une
                                    preuve d’identité. Une fois la demande approuvée, vous
                                    obtiendrez votre prêt par virement interac dans les 24 heures
                                    suivantes!
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Nos autres prêts allant jusqu’à 1 500$</h2>

                    <p className="sect-subtitle">
                        Réparation imprévue sur la voiture, téléphone brisé, facture inattendue…
                        Quelles que soient les conditions, nous n’avons pas besoin de connaître les
                        raisons de votre emprunt. Peu importe votre situation financière ou votre
                        score de crédit, vous pouvez faire une demande de prêt rapide de 200$ ou
                        plus avec Argent Aujourd’hui :
                    </p>

                    <div className="loan-options">
                        <ul>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 100$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 300$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 500$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 700$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 000$</li>
                            </Link>
                            <Link to="/new-lead" className="steps-options">
                                <li>Prêt de 1 500$</li>
                            </Link>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Les avantages de notre prêt de 200$</h2>

                    <p className="sect-subtitle">
                        Trouver un prêteur fiable et qui répond à ses besoins peut être éprouvant,
                        en plus de vous prendre un temps précieux. Pour simplifier votre recherche,
                        Argent Aujourd’hui vous propose une comparaison instantanée de vos options
                        de financement. En explorant les micros prêts de 200$ sur notre site, vous
                        bénéficiez des avantages suivants :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 30 }}>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Prêts sans enquête de crédit</h4>

                            <span style={{ marginTop: 130 }}>
                                Nos partenaires proposent des prêts IBV, c’est-à-dire par
                                vérification bancaire instantanée. De plus, les demandes de prêt à
                                court terme n'affectent pas votre score de crédit!
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Partenaires vérifiés</h4>

                            <span style={{ marginTop: 130 }}>
                                Nous travaillons uniquement avec des institutions enregistrées au
                                Registre des entreprises du Québec et qui détiennent les permis et
                                accréditations de l’
                                <a
                                    href="https://www.opc.gouv.qc.ca/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Office de la protection du consommateur
                                </a>
                                .
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Une démarche simple et rapide</h4>

                            <span style={{ marginTop: 130 }}>
                                Pour simplifier et accélérer l’obtention de prêts d’urgence, la
                                recherche et la demande se font entièrement en ligne. Prenez en
                                compte les heures d’ouverture de chaque institution pour évaluer
                                leur délai de réponse!
                            </span>
                        </li>
                        <li style={{ marginBottom: 30 }}>
                            <h4>Prêts sans refus</h4>

                            <span style={{ marginTop: 130 }}>
                                Les avances de fond sont sans vérification d’historique de crédit et
                                accessibles même si vous êtes présentement sans emploi.
                            </span>
                        </li>
                    </ul>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">
                        Pour quel besoin utiliser nos mini prêts de 200$?
                    </h2>

                    <p className="sect-subtitle">
                        Les prêts immédiats offrent une alternative efficace dans différentes
                        situations :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 20 }}>
                        <li>Prêt personnel</li>
                        <li>Avance de fonds</li>
                        <li>Prêt sur salaire</li>
                        <li>Prêt d'urgence</li>
                    </ul>
                </div>
            </section>

            <section className="Eligible sect-bg-dark">
                <div className="card" data-aos="fade-up">
                    <div className="content">
                        <div className="section-title">
                            <h2>Êtes-vous éligible?</h2>
                        </div>
                        <p>
                            Nos prêts se font sans justificatifs de salaire et n’affectent pas votre
                            score de crédit. Pour bénéficier d’un prêt rapide de 200$ avec l’un de
                            nos partenaires, vous devez simplement répondre aux critères suivants :
                        </p>
                        <ul>
                            <li>Avoir au moins 18 ans</li>
                            <li>Résider au Québec</li>
                            <li>Avoir un revenu stable</li>
                            <li>Ne pas avoir d’opposition de paiement</li>
                            <li>
                                Avoir le moins de frais de fonds non suffisants possible (frais NSF)
                            </li>
                        </ul>
                        <p>
                            Vous cherchez un prêt de 200$ sans emploi, ou un prêt en cas de mauvais
                            crédit? Explorez vos possibilités en quelques clics!
                        </p>
                        <Link to="/new-lead" className="btn">
                            Demander un prêt
                        </Link>
                    </div>
                </div>
            </section>

            {/* <ClientsBanner /> */}

            <Footer />
        </div>
    )
}
